// src/components/common/IdDisplayWithCopy.jsx (New File)
import React from 'react';
import { Typography, IconButton, Tooltip, Stack } from '@mui/material';
import { ContentCopy as CopyIcon } from '@mui/icons-material';
import { toast } from 'react-toastify';

const IdDisplayWithCopy = ({ id, label = "ID", idPrefix = "ID: ...", idSuffixLength = 6, noWrap = false }) => {
  if (!id) return null;

  const displayId = `${idPrefix}${id.slice(-idSuffixLength)}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(id)
      .then(() => toast.success(`${label} copied to clipboard!`))
      .catch(() => toast.error(`Failed to copy ${label}.`));
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ display: 'inline-flex' }}>
      <Typography variant="caption" color="text.secondary" noWrap={noWrap}>
        {displayId}
      </Typography>
      <Tooltip title={`Copy full ${label.toLowerCase()}: ${id}`}>
        <IconButton onClick={handleCopy} size="small" sx={{p: '2px'}}>
          <CopyIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default IdDisplayWithCopy;